export default __webpack_public_path__ + "static/media/Amelia 9781408312919.86baf563.jpg";